import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "type",
  "use": "type-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"type\"><path fill-rule=\"evenodd\" d=\"M1 5h18v1H1zm3 4h12v1H4zm3 4h6v1H7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol